// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app[data-v-e4731dd0] {\n  background: #efefef;\n  color: darkblue;\n  height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
